
export default {
  namespaced: true,

  state: () => ({
    isOpen: false,
    mainMenu: [],
    footerMenu: [],
    categoryMenu: [],
    infoMenu: [],
  }),

  getters: {
    isOpen: state => state.isOpen,
    mainMenu: state => state.mainMenu,
    categoryMenu: state => state.categoryMenu,
    footerMenu: state => state.footerMenu?.[0] || [],
    infoMenu: state => state.infoMenu || [],
  },

  mutations: {
    toggleMenu: state => {
      state.isOpen = !state.isOpen;
    },

    setMainMenu: (state, payload = []) => {
      state.mainMenu = payload;
    },

    setFooterMenu: (state, menu = []) => {
      state.footerMenu = menu;
    },

    setCategoryMenu: (state, menu = []) => {
      state.categoryMenu = menu;
    },

    setInfoMenu: (state, menu = []) => {
      state.infoMenu = menu;
    }
  },

  actions: {
    loadMainMenu({ commit }) {
      return this.$api.loadMenu(['main_menu'])
        .then(({ main_menu = [] } = {}) => {
          commit('setMainMenu', main_menu);
        })
        .catch(() => {
          commit('setMainMenu');
        });
    },
    loadFooterMenu({ commit }, slot = 'footer_menu') {
      // тянем их по отдельности,
      // проверить быстрее ли будет работать распаралеливание
      return this.$api.loadMenu([slot])
        .then((menu = {}) => {
          commit('setFooterMenu', menu[slot]);
        })
        .catch(() => {});
    },

    loadCategoryMenu({ commit, rootState }, slot = `category-${rootState.route.path}`) {
      return this.$api.loadMenu([encodeURIComponent(slot)])
        .then((menu = {}) => {
          commit('setCategoryMenu', menu[slot]);
        })
        .catch(() => {});
    },

    loadInfoMenu({ commit }, slot = 'info_menu') {
      return this.$api.loadMenu([slot])
        .then((menu = {}) => {
          commit('setInfoMenu', menu[slot]);
        })
        .catch(() => {});
    },
  }
}
